import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivCreateDocumentRuleDtoGen,
  MrfiktivDocumentIdsAiDtoGen,
  MrfiktivDocumentRuleControllerGetParamsGen,
  MrfiktivImproveDocumentRuleDtoGen
} from "../v1/data-contracts";
import { DocumentRule } from "../v1/DocumentRule";

/**
 * Communicate with documentRule API
 */
class DocumentRuleService {
  mrfiktivProxy: DocumentRule;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new DocumentRule(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create an documentRule
   */
  async create(partnerId: string, data: MrfiktivCreateDocumentRuleDtoGen) {
    const documentRule = (await this.mrfiktivProxy.documentRuleControllerCreate(partnerId, data)).data;

    return documentRule;
  }

  /**
   * Get all documentRule
   */
  async get(data: MrfiktivDocumentRuleControllerGetParamsGen) {
    const documentRules = (await this.mrfiktivProxy.documentRuleControllerGet(data)).data;

    return documentRules;
  }

  /**
   * Get a documentRule
   */
  async getOne(partnerId: string, documentRuleId: string) {
    const documentRule = (await this.mrfiktivProxy.documentRuleControllerGetOne(partnerId, documentRuleId)).data;

    return documentRule;
  }

  /**
   * Update a documentRule
   */
  async update(partnerId: string, documentRuleId: string, data: MrfiktivCreateDocumentRuleDtoGen) {
    const documentRule = (await this.mrfiktivProxy.documentRuleControllerUpdate(partnerId, documentRuleId, data)).data;

    return documentRule;
  }

  async improve(partnerId: string, data: MrfiktivImproveDocumentRuleDtoGen) {
    const result = (await this.mrfiktivProxy.documentRuleControllerImprove(partnerId, data)).data;

    return result;
  }

  /**
   * Test a single rule against a PDF in isolation
   */
  async testRun(partnerId: string, documentRuleId: string, data: MrfiktivDocumentIdsAiDtoGen) {
    const result = (await this.mrfiktivProxy.documentRuleControllerTest(partnerId, documentRuleId, data)).data;

    return result;
  }

  /**
   * Delete a documentRule
   */
  async delete(partnerId: string, documentRuleId: string) {
    const documentRule = (await this.mrfiktivProxy.documentRuleControllerDelete(partnerId, documentRuleId)).data;

    return documentRule;
  }
}

/**
 * Communicate with documentRule API
 */
export default new DocumentRuleService(new MrfiktivHttpClientProvider());
